import { useEffect, useState } from 'react';
import KeyHandler from '@/components/KeyHandler';

const PageTableKeyHandler = ({ row, tab = '.comp-page-tab', searchElement = '.comp-input input' }) => {
  const [activeIndex, setActiveIndex] = useState(null);

  const keyHandlers = {
    down:
      (shift = false) =>
      () => {
        const rows = document.querySelectorAll(row);
        const numberOfRows = rows.length;

        if (numberOfRows === 0) {
          return;
        }

        if (numberOfRows === 1) {
          setActiveIndex(0);
          rows[0].classList.add('active');
          return;
        }

        const currentIndex = typeof activeIndex === 'number' ? activeIndex : -1;
        const newIndex = currentIndex + 1;

        if (newIndex <= numberOfRows - 1) {
          const isSelectable = rows[newIndex].classList.contains('selectable');
          if (shift && isSelectable) {
            const hasSelected = Array.from(rows).some((row) => row.classList.contains('selected'));

            if (!hasSelected) {
              rows[currentIndex].querySelector('.row-v2-checkbox')?.click();
            }

            rows[newIndex].querySelector('.row-v2-checkbox')?.click();
          }

          setActiveIndex(newIndex);
          rows.forEach((row) => row.classList.remove('active'));
          setTimeout(() => {
            rows[newIndex].classList.add('active');
          }, 10);
        }
      },
    up:
      (shift = false) =>
      () => {
        const rows = document.querySelectorAll(row);

        if (rows.length === 0) {
          return;
        }

        if (rows.length === 1) {
          setActiveIndex(0);
          rows[0].classList.add('active');
          return;
        }

        const currentIndex = typeof activeIndex === 'number' ? activeIndex : -1;
        const newIndex = currentIndex - 1;

        if (newIndex >= 0) {
          const isSelectable = rows[newIndex].classList.contains('selectable');
          if (shift && isSelectable) {
            const hasSelected = Array.from(rows).some((row) => row.classList.contains('selected'));

            if (!hasSelected || rows[currentIndex].classList.contains('selected')) {
              rows[currentIndex].querySelector('.row-v2-checkbox')?.click();
            }

            rows[newIndex].querySelector('.row-v2-checkbox')?.click();
          }

          setActiveIndex(newIndex);
          rows.forEach((row) => row.classList.remove('active'));
          setTimeout(() => {
            rows[newIndex].classList.add('active');
          }, 10);
        }
      },
    right: () => {
      const hasSearchValue = document.querySelector(searchElement)?.value;
      if (hasSearchValue) {
        return;
      }

      const tabs = document.querySelectorAll(tab);

      const activeIndex = Array.from(tabs).findIndex((tab) => tab.classList.contains('active'));
      const newIndex = activeIndex + 1;

      if (newIndex <= tabs.length - 1) {
        tabs[newIndex].click();
        setActiveIndex(null);
      }
    },
    left: () => {
      const hasSearchValue = document.querySelector(searchElement)?.value;
      if (hasSearchValue) {
        return;
      }

      const tabs = document.querySelectorAll(tab);

      const activeIndex = Array.from(tabs).findIndex((tab) => tab.classList.contains('active'));
      const newIndex = activeIndex - 1;

      if (newIndex >= 0) {
        tabs[newIndex].click();
        setActiveIndex(null);
      }
    },
    submit: () => {
      document.querySelector(`${row}.active`)?.click();
    },
    escape: () => {
      const isModalOpen = document.querySelector('.comp-modal-v2');
      if (isModalOpen) {
        return;
      }

      document.querySelector(searchElement)?.focus();

      document.querySelectorAll(`${row}.selected`)?.forEach((row) => {
        row.querySelector('.row-v2-checkbox')?.click();
      });
    }
  };

  const searchKeyMap = {
    ArrowDown: keyHandlers.down(),
    'Shift+ArrowDown': keyHandlers.down(true),
    PageDown: keyHandlers.down(),

    ArrowUp: keyHandlers.up(),
    'Shift+ArrowUp': keyHandlers.up(true),
    PageUp: keyHandlers.up(),

    ArrowRight: keyHandlers.right,
    'Shift+ArrowRight': keyHandlers.right,

    ArrowLeft: keyHandlers.left,
    'Shift+ArrowLeft': keyHandlers.left,

    Enter: keyHandlers.submit
  };

  const globalKeyMap = {
    Escape: keyHandlers.escape
  };

  useEffect(() => {
    document.querySelector(searchElement)?.focus();
  }, [searchElement]);

  useEffect(() => {
    const searchInput = document.querySelector(searchElement);
    if (searchInput) {
      const resetActiveRow = () => {
        setActiveIndex(null);
        const rows = document.querySelectorAll(row);
        rows.forEach((row) => row.classList.remove('active'));
      };

      searchInput.addEventListener('input', resetActiveRow);

      return () => {
        searchInput.removeEventListener('input', resetActiveRow);
      };
    }
  }, [row, searchElement]);

  return (
    <>
      <KeyHandler keyMap={searchKeyMap} target={searchElement} />
      <KeyHandler keyMap={globalKeyMap} global={true} />
    </>
  );
};

export default PageTableKeyHandler;
